export default __webpack_public_path__ + "static/media/hht2_ep04_book_wp_01.cd313aa5.jpg";